<p-tabView [(activeIndex)]="index" (onChange)="getIndex($event)">
    <p-tabPanel header="Setting">
        <p-table [value]="crmSettingFieldsList" dataKey="id" [expandedRowKeys]="expandedRows">
            <ng-template pTemplate="header">
                <tr>
                    <!-- <th style="width: 1rem;"></th> -->
                    <th>Name</th>
                    <th>Value</th>
                    <th style="width: 200px;" class="p-text-right">Action</th>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-product let-expanded="expanded">
                <tr>
                    <!-- <td class="action">
                        <button type="button" pButton pRipple [pRowToggler]="product"
                        class="p-button-text p-button-rounded p-button-plain"
                        *ngIf="product.children.length > 0 && product.isActive"
                        [icon]="expanded ? 'pi pi-chevron-down' : 'pi pi-chevron-right'"></button>
                    </td> -->
                    <td>
                        {{product.name}}
                    </td>
                    <td>
                        <div class="p-d-flex p-ai-center">
                            {{product.code=='defaultAddress' ? selectedAddress?.name : product?.displayValue}}
                            <span *ngIf="product?.displayValue || (product.code=='defaultAddress' && selectedAddress?.name)" class="p-d-flex p-ai-center p-jc-center pi pi-pencil btnBars p-ml-2" pTooltip="Edit" tooltipPosition="top" (click)="editCsetting(product)">
                            </span>
                            <span *ngIf="!(product?.displayValue || (product.code=='defaultAddress' && selectedAddress?.name))" class="hyper-link cursor-pointer p-ml-2" pTooltip="Edit" tooltipPosition="top" (click)="editCsetting(product)">Set Value</span>
                        </div>
                    </td>
                    <td class="p-text-right">
                        <p-inputSwitch (onChange)="changeCrmSeetings(product)" [(ngModel)]="product.enabled" [disabled]="product.actionDisabled"></p-inputSwitch>
                    </td>
                </tr>
            </ng-template>
        </p-table>
    </p-tabPanel>
    <!-- <p-tabPanel [disabled]="true" headerStyleClass="iconPanel">
        <ng-template pTemplate="header">
            <p-menu
                #configmenuOrders
                id="config_menu_orders"
                [model]="configMenuOrdersItems"
                [popup]="true"
                appendTo="body"
            >
            </p-menu>
            <span
                class="btnBars p-mr-0"
                (click)="configmenuOrders.toggle($event)"
            >
                <i class="pi pi-bars"></i>
            </span>
        </ng-template>
    </p-tabPanel> -->
</p-tabView>

<p-dialog  styleClass="notes" [(visible)]="displayAddressEdit" [modal]="true" [responsive]="true"  [style]="{width: '500px', maxWidth: '35vw'}" [closable]="false">
    <p-header>
        <h5 class="p-d-inline-block p-mb-0">
            {{ selectedSettings?.name }}
        </h5>
    </p-header>
    <div class="p-grid">
        <div class="p-col-12">
            <label for="channel">Default Address Type</label>
            <p-dropdown id="channel" [options]="addressTypes" optionLabel="name" optionValue="id" placeholder="Select any" [(ngModel)]="selectedAddresId" appendTo="body"></p-dropdown>
        </div>
    </div>
    <ng-template pTemplate="footer">
        <button pButton label="Close" (click)="displayAddressEdit = false" class="p-button-secondary"></button>
        <button pButton label="Save"  (click)="onSaveAddress()" [disabled]="!selectedAddresId"></button>
    </ng-template>
</p-dialog>

<p-dialog  styleClass="notes" [(visible)]="displayVisitEdit" [modal]="true" [responsive]="true"  [style]="{width: '500px', maxWidth: '35vw'}" [closable]="false">
    <p-header>
        <h5 class="p-d-inline-block p-mb-0">
            {{ selectedSettings?.name }}
        </h5>
    </p-header>
    <div class="p-grid">
        <div class="p-col-12">
            <label for="channel">Select Time Range</label>
            <div class="p-d-flex">
                <input pInputText type="number" min="1" step="1" [(ngModel)]="visitRangeValue" class="p-mr-3"/>
                <p-dropdown [options]="occurrenceTypes" optionLabel="name" optionValue="id" placeholder="Select any" [(ngModel)]="visitRangeUnitId" appendTo="body" class="w-100"></p-dropdown>
            </div>
        </div>
    </div>
    <ng-template pTemplate="footer">
        <button pButton label="Close" (click)="displayVisitEdit = false" class="p-button-secondary"></button>
        <button pButton label="Save" (click)="saveVisitSetting()" [disabled]="!visitRangeValue || !visitRangeUnitId"></button>
    </ng-template>
</p-dialog>

<p-dialog  styleClass="notes" [(visible)]="displayVisitRadiusEdit" [modal]="true" [responsive]="true"  [style]="{width: '500px', maxWidth: '35vw'}" [closable]="false">
    <p-header>
        <h5 class="p-d-inline-block p-mb-0">
            {{ selectedSettings?.name }}
        </h5>
    </p-header>
    <div class="p-grid">
        <div class="p-col-12">
            <label for="channel">Geo Matched Radius</label>
            <div class="p-d-flex">
                <input pInputText type="number" min="0.01" step="0.1" [(ngModel)]="visitRadiusValue" class="p-mr-3"/>
                <p-dropdown [options]="visitRadiusUnits" optionLabel="name" optionValue="id" placeholder="Select Unit" [(ngModel)]="visitRadiusUnitId" appendTo="body" class="w-100"></p-dropdown>
            </div>
        </div>
    </div>
    <ng-template pTemplate="footer">
        <button pButton label="Close" (click)="displayVisitRadiusEdit = false" class="p-button-secondary"></button>
        <button pButton label="Save" (click)="saveVisitRadiusSetting()" [disabled]="!visitRadiusValue || visitRadiusValue<(0.01) || !visitRadiusUnitId"></button>
    </ng-template>
</p-dialog>
